import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './features/layout/layout.module';
import { MainModule } from './features/webapp/main.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { PagerModule } from '@progress/kendo-angular-pager';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { OAuthModule, AuthConfig, ValidationHandler, OAuthStorage, OAuthModuleConfig} from 'angular-oauth2-oidc';


import { authConfig , authModuleConfig} from './core/auth-config';

export function storageFactory(): OAuthStorage {
  return localStorage;
}


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    LayoutModule,
    MainModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    InputsModule,
    ButtonsModule,
    ButtonsModule,
    IconsModule,
    IndicatorsModule,
    DialogsModule,
    ListViewModule,
    PagerModule,
    TooltipModule,
    NgbModule,
    OAuthModule.forRoot(authModuleConfig)

  ],
  providers: [DatePipe,
    
    {provide: AuthConfig, useValue: authConfig},
    {provide: OAuthModuleConfig, useValue: authModuleConfig},
    {provide: OAuthStorage, useFactory: storageFactory}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
